
import { Component, Prop, Vue } from 'vue-property-decorator'

import isMobile from '@/widget/utils/isMobile'

let panelIdCounter = 0

@Component({})
export default class CheckoutPanel extends Vue {
  @Prop({ required: true, type: String }) readonly title!: string
  @Prop({ type: String, default: '' }) readonly subtitle!: string
  @Prop({ type: Boolean, default: false }) readonly unstyled!: boolean

  private readonly panelId: number = ++panelIdCounter
  private readonly isMobile = isMobile()

  get titleId(): string {
    return `checkout-panel-title-${this.panelId}`
  }

  get subtitleId(): string {
    return `checkout-panel-subtitle-${this.panelId}`
  }

  get hasContent(): boolean {
    return !!this.$slots.default
  }
}
